
const queryParams = new URLSearchParams(window.location.search);

const isDev = process.env.NODE_ENV === 'development';
export const preview = queryParams.has('preview') || isDev;

export const toolDebugger = queryParams.has('toolDebugger') || preview;